import { createRefetchContainer, graphql } from 'react-relay';
import EventSummaryComponent from './EventSummaryComponent';

export default createRefetchContainer(
  EventSummaryComponent,
  {
    viewer: graphql`
      fragment EventSummaryContainer_viewer on User {
        id
        past_referral_sources
        ...ContactSearchContainer_viewer
        ...ScheduleContainer_viewer
      }
    `,
    node: graphql`
      fragment EventSummaryContainer_node on Event {
        id
        user_event {
          id
          notes
          referral_source
          ...ScheduleContainer_node
        }
        user_contacts(first: 99999) @connection(key: "EventSummaryContainer_user_contacts") {
          edges {
            id
            role
            node {
              id
              first_name
              last_name
              company_name
              user_contact_addresses(first: 99999) @connection(key: "EventSummaryContainer_user_contact_addresses") {
                edges {
                  node {
                    id
                    label
                    line1
                    line2
                    city
                    province
                    postal_code
                    country
                  }
                }
              }
              user_contact_emails(first: 99999) @connection(key: "EventSummaryContainer_user_contact_emails") {
                edges {
                  node {
                    id
                    label
                    address
                  }
                }
              }
              user_contact_phones(first: 99999) @connection(key: "EventSummaryContainer_user_contact_phones") {
                edges {
                  node {
                    id
                    label
                    number
                  }
                }
              }
            }
          }
        }
      }
    `
  },
  graphql`
    query EventSummaryContainer_RefetchQuery($id: ID!) {
      node(id: $id) {
        ...EventSummaryContainer_node
      }
    }
  `
);



// WEBPACK FOOTER //
// ./webpack/components/Event/Show/EventSummaryContainer.js